import LicensesModel from '../Apis/Licenses'
import Controller from './Controller'

export default class LicensesController extends Controller {
  constructor() {
    super(new LicensesModel())
  }
}
